// removed by extract-text-webpack-plugin
module.exports = {"Title":"Title---BnwPL","Section":"Section---MeH1p","LabeledInput":"LabeledInput---2Md43","Subsection":"Subsection---8t0fl","Subsection__Title":"Subsection__Title---24NGq","Subsection__Body":"Subsection__Body---3BZoW"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/UserProfile/Section/styles.styl
// module id = sYT3
// module chunks = 89